/**
 * beneos-gold.js - fills the Beneos Gold page with the rates that actually apply.
 *
 * The page ships with a written fallback so it reads without JavaScript, but
 * every figure comes from the cloud, because the rates live in the admin and
 * will be tuned. A page that copies them starts lying at the first change.
 *
 * One request, public data, cached five minutes at the edge. No identity is
 * asserted and none is needed.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-bnx-gold]');
  if (!root) return;
  var proxy = root.getAttribute('data-proxy-url') || '/apps/beneos/library';

  /**
   * Die Stufengrenzen sind Patreon-Betraege und stehen immer in Euro, auch wenn
   * der Laden dem Besucher sonst seine eigene Waehrung zeigt. Die Einheit muss
   * deshalb drankleben, sonst liest ein Kunde in Kanada seine eigene hinein.
   */
  function euro(cents) {
    return (cents / 100).toFixed(2).replace(/\.00$/, '') + ' EUR';
  }

  function setText(sel, text) {
    var el = root.querySelector(sel);
    if (el) el.textContent = text;
  }

  function renderLadder(list) {
    var box = root.querySelector('[data-gd-ladder]');
    if (!box || !list || !list.length) return;
    box.textContent = '';
    list.forEach(function (item) {
      var row = document.createElement('div');
      row.className = 'gd-row';

      var what = document.createElement('span');
      what.className = 'gd-what';
      // Der Klassenname aus dem Laden ist Fremdtext, also nie als Markup.
      what.textContent = item.title;
      row.appendChild(what);

      var num = document.createElement('span');
      num.className = 'gd-num';
      num.textContent = String(item.gold);
      row.appendChild(num);

      var unit = document.createElement('span');
      unit.className = 'gd-unit';
      unit.textContent = 'gold';
      row.appendChild(unit);

      box.appendChild(row);
    });
  }

  fetch(proxy + (proxy.indexOf('?') === -1 ? '?' : '&') + 'resource=gold_rates', {
    credentials: 'same-origin'
  })
    .then(function (r) { return r.json(); })
    .then(function (res) {
      var d = (res && res.data) || {};
      var e = d.earn || {};

      Object.keys(e).forEach(function (k) {
        var el = root.querySelector('[data-gd="' + k + '"]');
        if (el) el.textContent = String(e[k]);
      });

      // Die Stufengrenzen als Betrag, damit niemand raten muss, in welcher er
      // steckt. Sie stehen im Admin und wandern mit.
      var t2 = d.tier2_from_cents || 0;
      var t3 = d.tier3_from_cents || 0;
      if (t2) setText('[data-gd-tier1-note]', 'Up to ' + euro(t2 - 1) + ' a month.');
      if (t2 && t3) setText('[data-gd-tier2-note]', euro(t2) + ' to ' + euro(t3 - 1) + ' a month.');
      if (t3) setText('[data-gd-tier3-note]', 'From ' + euro(t3) + ' a month.');

      var min = d.review_min_chars || 0;
      var cap = d.cap_year_reviews || 0;
      var note = 'A written review, whatever the rating.';
      if (cap) note += ' Up to ' + cap + ' a year.';
      setText('[data-gd-review-note]', note);

      renderLadder(d.ladder);
    })
    .catch(function () {
      // Der geschriebene Rueckfall steht schon in der Seite. Ein toter Abruf
      // laesst sie ungenau, aber lesbar; das ist besser als eine Bahn, die sich
      // selbst leert.
    });
})();
